module.exports = __webpack_public_path__ + "img/handraw_ordinateur.6b417773.svg";